
export default function HomeFounder() {
  return (
    <>
    <div className="home-founder">
        <div className="container">
            <div className="row">  

                <div className="col-lg-12">
                    <img src="/image/quote.webp" loading="lazy" alt="quote"/>
                    <p className="">We believe that design is not just a matter of aesthetics, but a concrete manifestation of values and emotions, where originality and authenticity always have a privileged place.</p>
                    <span>Team - <small>Saysha</small></span>
                </div>

            </div>
        </div>
    </div>
    </>
  )
}
